import { GridAction } from '@eforall/dashboard';
import { PersonEngagement } from '@interfaces';

export function getActions() {

	const actions: GridAction<PersonEngagement>[] = [];

	return actions;
}